



















import { Prop, Component, Vue } from "vue-property-decorator";
import { Project } from "@/api/project-api";
import { isNewProject } from "@/preferences";

interface DropdownItem {
  key: string;
  name: string;
  path: string;
}

const pathPattern = /\/projects\/.*?\/(.*)$/i;
const estimateScreenRouters = [
  "estimates",
  "invoice",
  "purchase",
  "expenses",
  "estimate-edit",
  "invoice-edit",
  "purchase-edit",
  "expenses-edit",
  "estimate-purchase",
  "report",
  "order-estimates",
  "order-invoice",
  "order-purchase",
  "order-estimate-edit",
  "order-invoice-edit",
  "order-purchase-edit",
  "order-estimate-purchase",
  "order-sale-report"
];
const oldEstimateScreenRouters = ["expenses", "expenses-edit"];
const orderEditRouters = [
  "estimate-edit",
  "invoice-edit",
  "purchase-edit",
  "expenses-edit",
  "estimate-purchase",
  "order-estimate-edit",
  "order-invoice-edit",
  "order-purchase-edit",
  "order-estimate-purchase"
];

@Component({})
export default class VProjectDropdown extends Vue {
  @Prop({ default: () => [] }) projects!: Project[];

  get items(): DropdownItem[] {
    return this.projects.map(p => ({
      key: String(p.projectId),
      name: p.name,
      path: this.createPath(p)
    }));
  }

  createPath(p: Project): string {
    if (!pathPattern.test(this.$route.path)) {
      return `/projects/${p.projectId}`;
    }
    let child = this.$route.path.replace(pathPattern, "$1");
    // If route name is not defined or not in the estimate screen routers, construct the path directly
    if (
      !this.$route.name ||
      !estimateScreenRouters.includes(this.$route.name)
    ) {
      return this.constructPath(p, child);
    }
    // Adjust the child path based on project creation date and route name
    child = this.adjustChildPathForProject(p, child);
    // Construct and return the final path
    return this.constructPath(p, child);
  }

  // Function to adjust the child path based on project creation date and route name
  adjustChildPathForProject(p: Project, child: string): string {
    const isNew = isNewProject(p.created); // Check if the project is new
    const startsWithOrders = child.startsWith("orders/"); // Check if the child path starts with "orders/"
    // Adjust the child path based on specific conditions related to project type and route name
    if (
      this.$route.name &&
      isNew &&
      oldEstimateScreenRouters.includes(this.$route.name)
    ) {
      return "orders/estimates"; // Special case for new projects in old estimate screen routers
    }
    if (this.$route.name && orderEditRouters.includes(this.$route.name)) {
      return isNew ? "orders/estimates" : "estimates"; // Change project from edit screen of estimate screen routers
    }
    if (isNew && !startsWithOrders) {
      return "orders/" + child; // Prefix with "orders/" if the project is new and child path does not start with it
    }
    if (!isNew && startsWithOrders) {
      return child.substring("orders/".length); // Remove "orders/" prefix if the project is not new
    }
    return child; // Return the original child path if no conditions are met
  }

  // Function to construct the final path based on project ID and child path
  constructPath(p: Project, child: string): string {
    return `/projects/${p.projectId}/${child}`;
  }
}
